import { DocumentService } from "./DocumentService";

export class CashRegisterReceiptsService extends DocumentService {
    async Clone(id: string) {
        const newObject = await this.Get(id);
        const clonedObject = { ...newObject };
        console.log('clonedObject is', clonedObject)
        return clonedObject;
    }
}